import { personalInfoQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useRemoveMfa() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: () => api.delete('/api/v1/mfa'),
    successLogAction: () => ({
      ActionType: ActionType.DisableTwoFactorAuth,
      Option: 'AuthenticatorApp',
    }),
    errorLogAction: () => ({
      ActionType: ActionType.DisableTwoFactorAuth,
      Option: 'AuthenticatorApp',
    }),
    onSuccess: (_res, _input, _mutateRes, { client }) => {
      client.setQueryData(personalInfoQueryOptions.queryKey, (old) =>
        old
          ? {
              ...old,
              Mfa: { Enabled: false, EnabledAt: null, Device: '', RecoveryCodesRemaining: null },
            }
          : old,
      );
      toast.show('success', t('Common.SnackBar.AuthenticatorAppRemoved'));
    },
  });
}
